// extracted by mini-css-extract-plugin
module.exports = {"next":"Next_next__5tJXc"};